import { useMemo, type ReactNode } from 'react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { useGetLojaAtualQuery } from '@/api';
import { ehTotem } from '@/lib/canal';

export const ESTILO_ACAO_KIOSK = {
  py: 2,
  fontSize: '1.15rem',
  fontWeight: 700,
  borderRadius: 3,
  textTransform: 'none',
} as const;

/** `tambemNoTotem`: tela do totem feita no tamanho do modal de delivery (a confirmação do pedido) também cresce. */
export function TemaKiosk({ children, tambemNoTotem = false }: { children: ReactNode; tambemNoTotem?: boolean }): JSX.Element {
  const base = useTheme();
  const { data: loja } = useGetLojaAtualQuery();
  const naEscalaDoCheckout = !!loja && ehTotem(loja.identificador);

  const tema = useMemo(
    () =>
      createTheme(base, {
        typography: {
          h3: { fontSize: 'clamp(24px, 3.0vmax, 34px)' },
          h4: { fontSize: 'clamp(20px, 2.5vmax, 28px)' },
          h5: { fontSize: 'clamp(17px, 2.1vmax, 23px)' },
          h6: { fontSize: 'clamp(15px, 1.8vmax, 20px)' },
          subtitle1: { fontSize: 'clamp(15px, 1.8vmax, 20px)' },
          subtitle2: { fontSize: 'clamp(14px, 1.6vmax, 18px)' },
          body1: { fontSize: 'clamp(14px, 1.7vmax, 19px)' },
          body2: { fontSize: 'clamp(13px, 1.5vmax, 17px)' },
          button: { fontSize: 'clamp(14px, 1.7vmax, 18px)' },
          caption: { fontSize: 'clamp(12px, 1.3vmax, 15px)' },
        },
      }),
    [base],
  );

  if (naEscalaDoCheckout && !tambemNoTotem) return <>{children}</>;

  return <ThemeProvider theme={tema}>{children}</ThemeProvider>;
}
